import Heading from "components/heading";
import HeroSection from "components/hero-section";
import { RankedTableDataProps } from "components/ranked-table/types";

import LenderFeaturesChart from "../integrations/lenders-chart";

const title = "Explore everything you can do with Enerflo Integrated Lenders";

const ExploreLenders = (props: RankedTableDataProps) => (
  <div className="bg-gray-100 px-4">
    <HeroSection title={title}>
      <div className="mx-auto w-full">
        <HeroSection.Content className="mx-auto mb-12 p-0 md:text-center md:px-4">
          <HeroSection.Header>
            <Heading tag="h3">{title}</Heading>
          </HeroSection.Header>
          <HeroSection.Description>
            Enerflo is always pushing the envelope on what’s possible, working closely with lenders to improve
            integrations and user experience.
          </HeroSection.Description>
        </HeroSection.Content>

        <div className="flex-grow">
          <LenderFeaturesChart className="rounded-t-lg" {...props} />
        </div>
      </div>
    </HeroSection>
  </div>
);

export default ExploreLenders;
